<template>
  <div
    class="notification__wrapper"
    :class="{ displayed: isDisplayed }"
  >
    <Card :class="notificationStyle">
      <p class="notification__title">
        <DynLang
          :by-key="title"
          :default-label="title"
        />
      </p>
      <div class="notification__content">
        <div class="notification__content__text">
          <DynLang
            :by-key="content"
            :default-label="content"
          />
        </div>
      </div>
      <div class="notification__buttons">
        <SplButton
          variant="link"
          @click="emitAcceptEvent()"
        >
          <TimesIcon
            :size="16"
            variant="dark"
          />
        </SplButton>
      </div>
    </Card>
  </div>
</template>

<script lang="ts">
import Card from './Card.vue'
import SplButton from './form/SplButton.vue'
import TimesIcon from './icons/Times.icon.vue'

export default defineNuxtComponent({
  components: {
    Card,
    SplButton,
    TimesIcon,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
    isDisplayed: {
      type: Boolean,
      default: () => true,
    },
    variant: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const notificationStyle = computed(() => {
      if (props.variant) {
        return `notification ${props.variant}`
      }

      return 'notification'
    })

    function emitAcceptEvent() { emit('onAccept') }
    function emitCancelEvent() { emit('onCancel') }

    return {
      notificationStyle,

      emitAcceptEvent,
      emitCancelEvent,
    }
  },
})
</script>

<style lang="scss" scoped>
.notification__wrapper {
  // @apply opacity-0;
  @apply h-0;
  @apply w-full;

  @apply fixed;
  @apply left-0;
  @apply top-30p;

  @apply opacity-0;

  @apply translate-x-full;

  @apply p-2;

  @apply z-30;
  @apply transition-all duration-500;

  pointer-events: none;
}

.notification__wrapper.displayed {
  @apply h-full;

  @apply opacity-100;

  @apply translate-x-0;

  pointer-events: auto;
}

.notification {
  @apply w-full;

  @apply py-4;
  @apply px-6;

  @apply border-2 border-spl-acent;
  box-shadow: 0 0 21px 0 rgba(0, 0, 0, 0.2);

  @apply bg-spl-white;

  @screen lg {
    @apply w-1085p;
    @apply mx-auto;
  }

  &__title {
    @apply font-bold;
  }

  &__content {
    // no
  }

  @apply relative;

  &__buttons {
    @apply absolute;

    @apply right-4;
    @apply top-4;

    @apply flex;
    @apply justify-end;
  }
}

.error {
  @apply border-spl-acent;
  .notification__title {
    @apply text-spl-acent-dark;
  }
}

.info {
  @apply border-spl-secondary-dark;
  .notification__title {
    @apply text-spl-primary-dark;
  }
}
</style>
